import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/trendelantero/PARRILLA-DE-SUSPENSION-1.png")